/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner } from './get-payment-request-detail200-response-approval-steps-inner-approver-candidates-inner';

/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseApprovalStepsInner
 */
export interface GetPaymentRequestDetail200ResponseApprovalStepsInner {
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'stepNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'approveType': GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'isApproved': boolean | null;
    /**
     * 
     * @type {Array<GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner>}
     * @memberof GetPaymentRequestDetail200ResponseApprovalStepsInner
     */
    'approverCandidates': Array<GetPaymentRequestDetail200ResponseApprovalStepsInnerApproverCandidatesInner>;
}

export const GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum = {
    all: 'APPROVE_BY_ALL',
    any: 'APPROVE_BY_ANY'
} as const;

export type GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum = typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum[keyof typeof GetPaymentRequestDetail200ResponseApprovalStepsInnerApproveTypeEnum];


